import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import FormRenderer from '../../../../../forms/FormRenderer'
import { FormElement, FormRender } from '../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs, getAllGroupVats } from '../../../../../utils/reducers/getters'
import { ProductExtendedTyShort, AddLangIdProductModelType } from '../../../types'

interface ShortMainRightProductLayoutProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    changeLang: (lang: string) => void
    selectedLang: string
}

const ShortMainRightProductLayout: React.FC<ShortMainRightProductLayoutProps> = ({ basicData, userPermissions, changeLang, selectedLang }) => {
    const { t } = useTwinTranslation()
    const groupVats = getAllGroupVats()
    const extraRightFields: FormElement<keyof AddLangIdProductModelType>[] = []
    if (basicData.reference) {
        extraRightFields.push({
            label: t('reference', 'Referencia'),
            name: 'reference',
            component: 'InputWithLabelMargin'
        })
    }

    const rightFields: FormRender<AddLangIdProductModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                ...extraRightFields,
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {}
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                },
            ]
        },
    ]
    const parsedRightFields = valueOrDefaultValue(rightFields, userPermissions, basicData)
    return (
        <div className='flex flex-col w-1/4 notFlexAutoFormRender product_container_right'>
            <FormRenderer sections={parsedRightFields} antiUnsaveTrigger={true} />
        </div>
    )
}

export default ShortMainRightProductLayout